<template>
  <div>
    <!-- Add Filter Bar-->
    <!-- Add Course Filter dropdown with All options included-->
    <!-- Add date filter dropdown-->

    <!-- Add bar chart to show concluded and pending users general (filtered by course) -->
    <!-- Add bar chart to show concluded and pending users classified by departments -->
    <!-- Show table with pending users only (small table) -->
    <!-- Add bar chart to show succeed and failed exams  -->
    <b-card no-body>
      <b-row class="mx-1 mt-1">
        <b-col cols="2">
          <div class="mb-2">
            <label style="font-size: 16px;" for="dateSelectId" class="form-label">{{ $t("Date") }}</label>
            <v-select id="dateSelectId" :reduce="(val) => val.id" v-model="selectedDateFilterId" label="title"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="dateFilterOptions" class="select-size-lg" />
          </div>
        </b-col>
        <b-col cols="2">
          <label style="font-size: 16px;" for="courseSelectId" class="form-label">{{ $t("Courses") }}</label>
          <CoursePicker @selectionChanged="courseSelectionChanged" />
        </b-col>
        <b-col v-if="selectedDateFilterId === 4" md="2" class="mt-1">
          <b-form-group label-for="example-datepicker" label="Start date">
            <flat-pickr v-model="selectedStartDate" class="form-control" name="registrationStartDate"
              placeholder="Start date" @on-change="dateSelectionChanged" />
          </b-form-group>
        </b-col>
        <b-col v-if="selectedDateFilterId === 4" md="2" class="mt-1">
          <b-form-group label-for="example-datepicker" label="End date">
            <flat-pickr v-model="selectedEndDate" class="form-control" name="registrationStartDate"
              placeholder="End date" @on-change="dateSelectionChanged" />
          </b-form-group>
        </b-col>
        <b-col class="d-flex align-items-center justify-content-end fw-bold">
          <p class="fw-bolder">
            {{ formatDate(startDate) }} - {{ formatDate(endDate) }}
          </p>
        </b-col>
      </b-row>
    </b-card>
    <!-- All Courses Charts - Yan Yana -->
    <b-row>
      <b-col v-if="completedCoursesChart" cols="6">
        <HighchartColumn :key="JSON.stringify(completedCoursesChart)" :data="completedCoursesChart" />
      </b-col>
      <b-col v-if="courseSubscriberExamResultChart" cols="6">
        <HighchartColumn :key="JSON.stringify(courseSubscriberExamResultChart)"
          :data="courseSubscriberExamResultChart" />
      </b-col>
    </b-row>
    <!-- Exam Results Chart - Tam Genişlik -->
    <b-row>
      <b-col cols="12" v-if="completedCourseByDepartmentChart">
        <HighchartColumn :key="JSON.stringify(completedCourseByDepartmentChart)"
          :data="completedCourseByDepartmentChart" />
      </b-col>
    </b-row>


    <!-- Time Spent Chart - Tam Genişlik -->
    <b-row v-if="courseTimeSpent">
      <b-col cols="12">
        <HighchartColumn :key="JSON.stringify(courseTimeSpent)" :data="courseTimeSpent" />
      </b-col>
    </b-row>
    <b-card v-if="courseCompletePendingList && courseCompletePendingList.length > 0">
      <b-card-title>
        <h3>{{ $t("Course Pending Users") }}</h3>
      </b-card-title>
      <b-row>
        <b-col cols="12" md="4" class="mb-1">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search...')" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table ref="refUserListTable" class="position-relative" :items="paginatedList" responsive primary-key="id"
            show-empty :empty-text="$t('No matching records found')">
            <template #cell(courseAssignedDate)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{
                  formatDate(data.item.courseAssignedDate)
                  }}</span>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-nowrap mr-1">{{ $t('Showing') }}</span>
            <b-form-select
              v-model="perPage"
              :options="perPageOptions"
              class="mx-1"
              style="width: 80px;"
            />
            <span class="text-nowrap">{{ $t('of') }} {{ dataMeta.of }} {{ $t('entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  ref,
  onUnmounted,
  computed,
  onMounted,
  watch,
} from "@vue/composition-api";
import {
  BCardBody,
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormInput,
  BFormSelect,
  BCardTitle,
  BFormGroup,
  BPagination,
} from "bootstrap-vue";
import store from "@/store";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import lmsDashboardStoreModule from "./lmsDashboardStoreModule";
import HighchartColumn from "./components/HighchartColumn.vue";
import useLmsDashboard from "./useLmsDashboard";
import CoursePicker from "./components/CoursePicker.vue";

export default {
  components: {
    flatPickr,
    BCardTitle,
    HighchartColumn,
    BFormInput,
    BFormSelect,
    BFormGroup,
    BCardBody,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    CoursePicker,
    vSelect,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-lms-dashboard";
    const searchQuery = ref("");
    const currentPage = ref(1);
    const perPage = ref(10);
    const perPageOptions = [5, 10, 25, 50, 100];

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      store.registerModule(USER_APP_STORE_MODULE_NAME, lmsDashboardStoreModule);
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
      }
    });
    onMounted(() => { });

    const dateFilterOptions = [
      {
        id: 1,
        title: `Weekly`,
      },
      { id: 2, title: `Monthly` },
      {
        id: 3,
        title: `Yearly`,
      },
      {
        id: 4,
        title: `Custom`,
      },
    ];
    const selectedStartDate = ref(new Date());
    const selectedEndDate = ref(new Date());

    const selectedDateFilterId = ref(3);

    const coursesDropdown = computed(() => {
      return store.getters["app-lms-dashboard/getCourses"];
    });

    const selectedCourse = ref(0);

    const {
      startDate,
      endDate,
      fetchDashboardData,
      completedCoursesChart,
      completedCourseByDepartmentChart,
      courseSubscriberExamResultChart,
      courseTimeSpent,
      courseCompletePendingList,
    } = useLmsDashboard(
      selectedCourse,
      selectedDateFilterId,
      selectedStartDate,
      selectedEndDate
    );

    const courseSelectionChanged = (newVal) => {
      selectedCourse.value = newVal;
    };
    const dateSelectionChanged = () => {
      fetchDashboardData();
    };
    watch(selectedDateFilterId, (newVal) => {
      fetchDashboardData();
    });

    // Reset page to 1 when search query changes
    watch(searchQuery, () => {
      currentPage.value = 1;
    });

    // Reset page to 1 when per page changes
    watch(perPage, () => {
      currentPage.value = 1;
    });

    // Filtered list based on search query
    const filteredList = computed(() => {
      if (!courseCompletePendingList.value) return [];

      const query = searchQuery.value.toLowerCase().trim();
      if (!query) return courseCompletePendingList.value;

      return courseCompletePendingList.value.filter(item => {
        // Search through all object values
        return Object.values(item).some(value => {
          if (value === null || value === undefined) return false;
          return String(value).toLowerCase().includes(query);
        });
      });
    });

    // Paginated list - slice the filtered list for current page
    const paginatedList = computed(() => {
      const start = (currentPage.value - 1) * perPage.value;
      const end = start + perPage.value;
      return filteredList.value.slice(start, end);
    });

    // Pagination computed properties based on filtered list
    const totalRows = computed(() => {
      return filteredList.value ? filteredList.value.length : 0;
    });

    const dataMeta = computed(() => {
      const localItemsCount = paginatedList.value.length;
      const totalItems = totalRows.value;
      return {
        from: totalItems > 0 ? perPage.value * (currentPage.value - 1) + 1 : 0,
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalItems,
      };
    });

    function formatDate(dateString) {
      if (!dateString) {
        return "";
      }
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      };

      const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
        date
      );
      return formattedDate.replace(",", "");
    }

    return {
      startDate,
      endDate,
      formatDate,
      searchQuery,
      courseCompletePendingList,
      courseSelectionChanged,
      dateSelectionChanged,
      completedCoursesChart,
      completedCourseByDepartmentChart,
      courseSubscriberExamResultChart,
      dateFilterOptions,
      selectedDateFilterId,
      coursesDropdown,
      courseTimeSpent,
      selectedCourse,
      selectedStartDate,
      selectedEndDate,
      currentPage,
      perPage,
      perPageOptions,
      totalRows,
      dataMeta,
      filteredList,
      paginatedList,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
